export const ConfigCertificados = {
   barraBusqueda: {
      criterios: ["Rut Certificado", "Nombre Certificado"],
      criteriosKeys: ["rut", "nombre"],
      criterioPrincipal: "Rut Certificado",
   },
   table: {
      title: "Mantenedor Certificado",
      add: "Carga Documento",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};

export const CERT_PRECIOS = {
   1: { base: 11990, garantia: 2990, reposicion: 5990 },
   2: { base: 17990, garantia: 3990, reposicion: 8990 },
   3: { base: 23990, garantia: 4990, reposicion: 11990 }
 } as const;